<template>
  <!-- 通用表格模板组件 -->
  <div class="table-comp">
    <!-- 顶部搜索模块 -->
    <el-form
      v-show="table.showSearchBar"
      ref="queryForm"
      :inline="true"
      :model="table.defaultParams"
    >
      <el-form-item
        v-for="(option, opIndex) of table.searchOptions"
        :key="opIndex"
        :label="option.label"
        v-if="opIndex < minNum"
      >
        <el-select
          v-if="option.type === 'dict'"
          v-model="option.value"
          class="handle-select"
          clearable
          filterable
          :multiple="option.multiple"
          :placeholder="option.placeholder"
          size=""
          style="width: 225px"
          @change="searchSelectFn(option)"
        >
          <el-option
            v-for="(selectOption, i) in dictData[option.dictKey]"
            :key="i"
            :label="selectOption.desc"
            :value="selectOption.code"
          />
        </el-select>
        <el-select
          v-if="option.type === 'select'"
          v-model="option.value"
          class="handle-select"
          clearable
          filterable
          :multiple="option.multiple"
          :placeholder="option.placeholder"
          size=""
          style="width: 225px"
          @change="searchSelectFn(option)"
        >
          <el-option
            v-for="selectOption in option.options"
            :key="selectOption.key"
            :label="selectOption.label"
            :value="selectOption.id"
          />
        </el-select>
        <el-cascader
          v-if="option.type === 'cascader'"
          v-model="option.value"
          size="small"
          style="width: 225px"
          filterable
          :show-all-levels="option.showAllLevels"
          :props="{
            checkStrictly: option.props.checkStrictly,
            multiple: option.props.multiple,
            value: option.props.value ? option.props.value : 'ID',
            children: option.props.children
              ? option.props.children
              : 'children',
            label: option.props.label ? option.props.label : 'label',
          }"
          :options="option.options"
          placeholder="全部"
          clearable
          @change="searchSelectFn"
        />
        <el-cascader
          ref="cascader2"
          v-if="option.type === 'cascader2'"
          v-model="option.value"
          size="small"
          filterable
          style="width: 225px"
          :show-all-levels="option.showAllLevels"
          :props="{
            lazy: true,
            lazyLoad: loadNode,
            checkStrictly: false,
            multiple: option.props.multiple,
            value: 'productCategoryId',
            label: 'categoryName',
            children: 'children',
          }"
          :options="option.options"
          placeholder="全部"
          clearable
          @change="searchSelectFn"
        />
        <el-cascader
          v-if="option.type === 'city'"
          v-model="option.value"
          size="small"
          style="width: 225px"
          filterable
          :show-all-levels="option.showAllLevels"
          :props="{
            checkStrictly: option.props.checkStrictly,
            multiple: option.props.multiple,
            value: option.props.value ? option.props.value : 'ID',
            children: option.props.children
              ? option.props.children
              : 'children',
            label: option.props.label ? option.props.label : 'label',
          }"
          :options="option.options"
          placeholder="全部"
          clearable
          @change="searchSelectFn"
        />
        <el-date-picker
          v-if="option.type === 'date'"
          v-model="option.value"
          class="handle-date"
          clearable
          placeholder="选择日期"
          size=""
          style="width: 225px"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleSearch"
        />
        <el-date-picker
          v-if="option.type === 'daterange'"
          v-model="option.value"
          class="handle-date"
          :default-time="['00:00:00', '23:59:59']"
          :end-placeholder="option.endPlaceholder"
          :clearable="option.clearableIcon"
          range-separator="-"
          size=""
          :start-placeholder="option.startPlaceholder"
          style="width: 225px"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="option.pickerOptions"
          @change="handleSearch"
        />
        <el-date-picker
          v-if="option.type === 'datetimerange'"
          v-model="option.value"
          class="handle-date"
          :default-time="['00:00:00', '23:59:59']"
          :end-placeholder="option.endPlaceholder"
          clearable
          range-separator="-"
          size=""
          :start-placeholder="option.startPlaceholder"
          style="width: 360px"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleSearch"
        />
        <el-input
          v-if="option.type === 'input'"
          v-model="option.value"
          class="handle-input"
          clearable
          :maxlength="option.maxlength"
          :placeholder="option.placeholder"
          size=""
          style="width: 225px"
          @clear="handleSearch"
          @change="handleSearch"
          @keyup.enter.native="handleSearch"
        />
        <span class="ml5" v-if="option.rightText">{{ option.rightText }}</span>
        <div v-if="option.type === 'inputRange'" style="display: flex">
          <el-input
            v-model="option.value1"
            class="handle-input mr5"
            clearable
            :maxlength="option.maxlength"
            size=""
            style="width: 140px"
            @blur="checkInputMax(option.value1, option.value2, '1', $event)"
            @clear="handleSearch"
            @input.native="option.value1 = checkInputNum($event, '>zero')"
            @keyup.enter.native="handleSearch"
          >
            <template slot="append">{{ option.append }}</template>
          </el-input>
          <div class="mr5">~</div>
          <el-input
            v-model="option.value2"
            class="handle-input mr5"
            clearable
            :maxlength="option.maxlength"
            size=""
            style="width: 140px"
            @blur="checkInputMax(option.value1, option.value2, '2', $event)"
            @clear="handleSearch"
            @input.native="option.value2 = checkInputNum($event, '>zero')"
            @keyup.enter.native="handleSearch"
          >
            <template slot="append">{{ option.append }}</template>
          </el-input>
        </div>
        <div v-if="option.type === 'sup'">
          <el-input
            v-model="option.value"
            placeholder="请选择"
            style="width: 225px"
            @focus="showSelectSupplier"
            clearable
            @clear="hideSelectSupplier"
          />
        </div>
        <div v-if="option.type === 'textKey'" style="display: flex">
          <el-select
            v-model="option.value"
            class="select-left"
            placeholder="请选择"
            size=""
            style="width: 160px"
            @change="(val) => pulldownWrite(value, option.value)"
          >
            <el-option
              v-for="selectOption in option.options"
              :key="selectOption.id"
              :label="selectOption.label"
              :value="selectOption.id"
            />
          </el-select>
          <div
            v-for="(item, index) of option.searchData"
            :key="index"
            style="margin-top: -1px"
          >
            <el-input
              v-if="index == option.value"
              v-model.trim="textKeyValue"
              class="select-right"
              clearable
              maxlength="9999"
              :placeholder="item.placeholder"
              size=""
              style="width: 215px"
              @clear="textKeyClearInput"
              @keyup.enter.native="handleSearch"
            />
          </div>
        </div>

        <div v-if="option.type === 'timeType'" style="display: flex">
          <el-select
            v-model="option.value"
            class="select-left"
            placeholder="请选择"
            size=""
            style="width: 135px"
            @change="(val) => pulldownWrite2(value, option.value)"
          >
            <el-option
              v-for="selectOption in option.options"
              :key="selectOption.id"
              :label="selectOption.label"
              :value="selectOption.id"
            />
          </el-select>
          <div
            v-for="(item, index) of option.searchData"
            :key="index"
            style="margin-top: -1px"
          >
            <el-date-picker
              v-if="index == option.value"
              v-model="item.value"
              class="handle-date"
              clearable
              :default-time="['00:00:00', '23:59:59']"
              range-separator="-"
              size=""
              style="width: 360px"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleSearch"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="table.searchOptions.length > 0">
        <el-button
          class="search-reset-s"
          icon="el-icon-search"
          size=""
          type="primary"
          @click="handleSearch"
          :disabled="loading"
        >
          查 询
        </el-button>
        <el-button
          icon="el-icon-refresh-left"
          size=""
          @click="clearSearch"
          :disabled="loading"
        >
          重 置
        </el-button>
        <el-button
          v-if="table.searchOptions.length > 9"
          type="text"
          @click="handleFold"
        >
          <span v-if="fold">展开</span>
          <span v-else>收起</span>
          <vab-icon
            class="vab-dropdown"
            :class="{ 'vab-dropdown-active': fold }"
            icon="arrow-up-s-line"
          />
        </el-button>
      </el-form-item>
    </el-form>
    <div class="bottom-content">
      <!-- 表头tab及更多其它功能按钮 -->
      <div class="tab-more">
        <!-- 表头的新增等按钮 -->
        <div v-if="table.showMoreBtns" class="mb10">
          <span v-if="table.moreBtns.length > 0" class="button-title">
            快捷操作
          </span>
          <el-button
            v-for="moreItem in table.moreBtns"
            v-if="checkPermi([moreItem.hasPermi])"
            :key="moreItem.fn"
            v-preventReClick
            :icon="moreItem.icon"
            :plain="moreItem.plain"
            size="small"
            :type="moreItem.type"
            :disabled="moreItem.disabled"
            :loading="moreItem.loading"
            @click="moreOperation(moreItem.fn)"
          >
            {{ moreItem.text }}
          </el-button>
          <span class="ml20" v-if="table.redPacketPrice">
            红包总额：{{ table.redPacketPrice }}
          </span>
          <el-dropdown
            size="small"
            v-if="table.arrBtn && table.arrBtn.length > 0"
            class="ml10"
            @command="handleCommand"
          >
            <el-button type="primary">
              更多
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) of table.arrBtn"
                v-if="checkPermi([item.hasPermi])"
                :disabled="item.disabled"
                v-preventReClick
                :key="index"
                :command="item.fn"
              >
                {{ item.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <span
            v-if="table.updateTime"
            class="ml20 text-muted"
            style="font-size: 12px"
          >
            更新时间：{{ table.updateTime }}
          </span>
          <span
            v-if="table.leftText"
            class="ml20 text-muted"
            style="font-size: 12px"
          >
            {{ table.leftText }}
          </span>
        </div>
        <div
          v-if="table.rightText"
          class="flex-x mr10 mb10"
          style="flex: 1; justify-content: end"
        >
          {{ table.rightText }}
        </div>
        <!-- 右侧功能模块开始 -->
        <div v-if="table.canRefresh" style="display: flex; align-items: center">
          <el-tag
            v-for="(item, index) of table.rightTag"
            :key="index"
            class="ml10 mr10"
          >
            {{ item.name }} : {{ item.value }}
          </el-tag>
          <el-button
            v-if="table.rightBtn && checkPermi([table.rightBtn.hasPermi])"
            class="mr20"
            type="text"
            @click="operationFn(table.rightBtn, table.rightBtn.fn)"
          >
            {{ table.rightBtn.text }}
          </el-button>
          <el-row v-if="table.searchOptions" class="mb10">
            <el-tooltip
              class="item"
              :content="table.showSearchBar ? '隐藏搜索' : '显示搜索'"
              effect="dark"
              placement="right"
            >
              <el-button
                circle
                icon="el-icon-search"
                size="mini"
                @click="toggleSearch()"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              content="刷新"
              effect="dark"
              placement="right"
            >
              <el-button
                circle
                icon="el-icon-refresh"
                size="mini"
                @click="_initData()"
                :disabled="loading"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              content="显隐列"
              effect="dark"
              placement="right"
            >
              <el-button
                circle
                icon="el-icon-menu"
                size="mini"
                @click="open = true"
              />
            </el-tooltip>
          </el-row>
          <el-dialog
            append-to-body
            title="显示/隐藏"
            :visible.sync="open"
            width="630px"
            :close-on-click-modal="false"
          >
            <el-transfer
              v-model="value"
              :data="table.options"
              :titles="['显示', '隐藏']"
              @change="dataChange"
            />
          </el-dialog>
        </div>
        <!-- 右侧功能模块结束 -->
      </div>

      <!-- 表格模块 -->
      <el-table
        ref="table"
        v-loading="loading"
        class="table"
        :data="tableData"
        element-loading-background="rgba(0, 0, 0, 0.4)"
        element-loading-spinner="el-icon-loading"
        element-loading-text="拼命加载中"
        :row-style="rowstyle"
        :border="table.border"
        :summary-method="getSummaries"
        :show-summary="table.summary"
        :highlight-current-row="table.currentRow"
        @row-dblclick="handleSelect"
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        @current-change="handleCurrentChange"
        @select="handleSelect"
        @row-click="handleRowClick"
      >
        <el-table-column v-if="table.radio" width="55">
          <template slot="header">
            <span style="margin-left: 5px">单选</span>
          </template>
          <template slot-scope="scope">
            <div class="table-single-radio">
              <el-radio
                v-if="scope.row.contractId"
                v-model="tabelradio"
                :label="scope.row.contractId"
                style="color: #fff; padding-left: 12px; margin-right: -25px"
              />
              <el-radio
                v-else
                v-model="tabelradio"
                :label="scope.row.customerId"
                style="color: #fff; padding-left: 12px; margin-right: -25px"
                @change.native="getCurrentRow(scope.row)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="table.selection"
          align="center"
          :selectable="selectable"
          type="selection"
          width="55"
        />
        <el-table-column
          v-for="option in table.options"
          v-if="option.key && option.visible"
          :key="option.key"
          :align="option.align"
          :fixed="option.fixed"
          :label="option.label"
          :default-sort="{ prop: 'createTime', order: 'descending' }"
          :min-width="option.minWidth"
          :prop="option.key"
          :show-overflow-tooltip="option.tooltip"
          :sortable="option.sort ? option.key : false"
          :width="option.width"
        >
          <template v-if="option.header" slot="header">
            <span>{{ option.label }}</span>
            <el-tooltip
              class="item"
              content=""
              effect="light"
              placement="right"
            >
              <div slot="content" v-html="option.header"></div>
              <i
                class="el-icon-question realpointer"
                style="cursor: pointer"
              ></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div v-if="option.type === 'self'">
              <div v-for="opItem in scope.row[option.key]" :key="opItem.key">
                <div
                  v-if="opItem.html && opItem.type === 'txt'"
                  class="row-txt"
                  @click="
                    (event) => {
                      htmlClick(event, opItem.click)
                    }
                  "
                  v-html="opItem.html"
                ></div>
                <p v-if="!opItem.html && opItem.type === 'txt'" class="row-txt">
                  {{ opItem.content }}
                </p>
                <div v-if="opItem.type === 'btns'" style="margin-top: 10px">
                  <p
                    v-for="bItem in opItem.content"
                    v-if="bItem.icon && bItem.icon == 'eye'"
                    :key="bItem.key"
                    class="eye"
                    @click="columnBtns(scope, bItem.fn)"
                  >
                    <i></i>
                    {{ bItem.label }}
                  </p>
                  <el-button
                    v-for="bItem in opItem.content"
                    v-if="!bItem.icon"
                    :key="bItem.key"
                    size="mini"
                    type="primary"
                    @click="columnBtns(scope, bItem.fn)"
                  >
                    {{ bItem.label }}
                  </el-button>
                </div>
              </div>
            </div>

            <div v-else-if="option.type === 'status'">
              <div
                v-if="
                  option.overflow &&
                  scope.row[option.key] &&
                  scope.row[option.key].length > option.overflow
                "
              >
                <el-tooltip
                  class="item"
                  :content="isShowState(option, scope)"
                  effect="dark"
                  placement="top-end"
                >
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      cursor: pointer;
                    "
                  >
                    {{ isShowState(option, scope) }}
                  </div>
                </el-tooltip>
              </div>
              <div v-else>
                <span
                  v-if="isStateflag(option, scope)"
                  class="origin"
                  :style="{ background: isStateflag(option, scope) }"
                ></span>
                <div
                  style="
                    line-height: 40px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                  :style="{ color: isStateColor(option, scope) }"
                >
                  <span
                    v-if="option.showRedText && scope.row.noticeStatus == 2"
                    style="color: red"
                  >
                    {{ isShowState(option, scope) }}
                  </span>
                  <span v-else>{{ isShowState(option, scope) }}</span>
                  <el-tooltip
                    v-if="
                      option.tooltipText &&
                      scope.row.payStatus == 2 &&
                      scope.row.reviewerStatus != 2
                    "
                    :content="scope.row.failReason"
                    effect="light"
                    placement="right"
                  >
                    <i
                      class="el-icon-warning"
                      style="color: red; cursor: pointer"
                    ></i>
                  </el-tooltip>
                </div>

                <el-tooltip
                  v-if="scope.row.memberState == 2 && option.tooltipText"
                  class="item"
                  content=""
                  effect="light"
                  placement="right"
                >
                  <div slot="content">
                    <div v-if="scope.row.state == 5">
                      当前用户在{{ scope.row.quitTime }}被队长移除队伍；
                      若任务完成，则按业绩贡献率发放奖励
                    </div>
                    <div v-if="scope.row.state == 4">
                      当前用户在{{ scope.row.quitTime }}被取消分享官身份；
                      若任务完成，则按业绩贡献率发放奖励
                    </div>
                    <div v-if="scope.row.state == 2">
                      当前用户在{{ scope.row.quitTime }}自主退出队伍；
                      若任务完成，则奖励自动归队长所有
                    </div>
                  </div>
                  <i
                    class="el-icon-question realpointer"
                    style="cursor: pointer"
                  ></i>
                </el-tooltip>
              </div>
            </div>

            <div v-else-if="option.type === 'input'">
              <div v-if="!scope.row.edit" @click="handleEdit(scope)">
                {{ scope.row[option.key] }}
                <i class="el-icon-edit"></i>
              </div>
              <input
                v-else
                :ref="'input' + scope.row.taskCode"
                v-model="scope.row[option.key]"
                autofocus
                class="el-input__inner"
                type="text"
                @blur="handleEditSubmit(scope, option.fn)"
              />
              <!-- <el-input v-else :ref="'input'+scope.row.taskCode" v-model="scope.row[option.key]" class="handle-input" @blur="handleEditSubmit(scope,option.fn)"></el-input> -->
            </div>
            <div
              v-else-if="option.type === 'CommissionDesc'"
              style="display: flex; align-items: center"
            >
              <div
                v-if="scope.row['scheduledStatus'] == 1"
                style="display: flex; align-items: center"
              >
                <el-tooltip
                  class="item"
                  :content="
                    option.key == 'firstCommissionDesc'
                      ? '将于' +
                        scope.row['scheduledBeginTime'] +
                        ' 佣金奖励变更为' +
                        scope.row['scheduledRateFirst'] +
                        '%'
                      : '将于' +
                        scope.row['scheduledBeginTime'] +
                        ' 佣金奖励变更为' +
                        scope.row['scheduledRateSecond'] +
                        '%'
                  "
                  effect="dark"
                  placement="top-end"
                >
                  <div
                    v-if="scope.row[option.key]"
                    class="el-icon-alarm-clock ml5 mr5"
                    style="cursor: pointer"
                  ></div>
                </el-tooltip>
                <div>
                  {{ scope.row[option.key] }}
                </div>
              </div>
              <div v-else style="display: flex">
                <div style="width: 25px; height: 1px"></div>
                {{ scope.row[option.key] }}
              </div>
            </div>
            <div
              v-else-if="option.type === 'userInfo'"
              style="display: flex; align-items: center"
            >
              <div class="goodImg mr10">
                <el-image
                  v-if="scope.row.customerAvatar"
                  style="width: 40px; height: 40px"
                  class="imgs vipavator"
                  :src="scope.row.customerAvatar"
                  :preview-src-list="[scope.row.customerAvatar]"
                />
                <el-image
                  v-else
                  class="vipavator"
                  style="width: 40px; height: 40px"
                  src="https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png"
                  :preview-src-list="[
                    'https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png',
                  ]"
                />
              </div>
              <div style="display: flex; flex-direction: column">
                <div>{{ scope.row.customerName }}</div>
                <div>{{ scope.row.customerPhone }}</div>
              </div>
            </div>
            <div
              v-else-if="option.type === 'goodInfo'"
              style="display: flex; align-items: center"
            >
              <div class="goodImg mr10">
                <el-image
                  class="imgs"
                  :preview-src-list="[scope.row.goodsGallery.split(',')[0]]"
                  :src="scope.row.goodsGallery.split(',')[0]"
                  style="width: 40px; height: 40px"
                />
                <!-- <img class="imgs" :src="scope.row.goodsGalleryBaseStr" /> -->
              </div>
              <div v-if="option.goodsType">
                <el-tag class="mr5" size="mini" type="danger">
                  {{ option.goodsType }}
                </el-tag>
              </div>
              <div class="ml5" style="display: flex; flex-direction: column">
                <div>
                  <el-tooltip placement="right">
                    <div slot="content">{{ scope.row.goodsName }}</div>
                    <div
                      style="
                        width: 200px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ scope.row.goodsName }}
                    </div>
                  </el-tooltip>
                </div>
                <div>{{ scope.row.goodsSn }}</div>
              </div>
            </div>

            <div
              v-else-if="option.type === 'goodInfo2'"
              style="display: flex; align-items: center"
            >
              <div class="goodImg mr10">
                <el-image
                  class="imgs"
                  :preview-src-list="[scope.row.goodsGallery.split(',')[0]]"
                  :src="scope.row.goodsGallery.split(',')[0]"
                  style="width: 40px; height: 40px"
                />
                <!-- <img class="imgs" :src="scope.row.goodsGalleryBaseStr" /> -->
              </div>
              <div v-if="option.goodsType">
                <el-tag class="mr5" size="mini" type="danger">
                  {{ option.goodsType }}
                </el-tag>
              </div>
              <div class="ml5" style="display: flex; flex-direction: column">
                <div>
                  <el-tooltip placement="right">
                    <div slot="content" style="text-align: left">
                      {{ scope.row.goodsName }}
                    </div>
                    <div
                      style="
                        width: 130px;
                        text-align: left;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ scope.row.goodsName }}
                    </div>
                  </el-tooltip>
                </div>
                <div
                  v-if="scope.row.minPrice != scope.row.maxPrice"
                  style="text-align: left"
                >
                  ￥{{ scope.row.minPrice }}~￥{{ scope.row.maxPrice }}
                </div>
                <div v-else style="text-align: left">
                  ￥{{ scope.row.minPrice }}
                </div>
              </div>
            </div>

            <div
              v-else-if="option.type === 'customerInfo'"
              style="display: flex; align-items: center"
            >
              <div class="goodImg mr10">
                <el-image
                  class="imgs"
                  :preview-src-list="[
                    scope.row.customerAvatar
                      ? scope.row.customerAvatar
                      : 'https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png',
                  ]"
                  :src="
                    scope.row.customerAvatar
                      ? scope.row.customerAvatar
                      : 'https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png'
                  "
                  style="width: 40px; height: 40px"
                />
                <!-- <img class="imgs" :src="scope.row.goodsGalleryBaseStr" /> -->
              </div>
              <div style="display: flex; flex-direction: column">
                <div>
                  {{ scope.row.customerName ? scope.row.customerName : '-' }}
                </div>
                <div>
                  {{ scope.row.customerPhone ? scope.row.customerPhone : '-' }}
                </div>
              </div>
            </div>

            <div
              v-else-if="option.type === 'supplierSkuSettles'"
              style="
                display: flex;
                align-items: center;
                text-align: center;
                justify-content: center;
              "
            >
              <div>{{ divideByHundred(scope.row[option.key]) }}</div>

              <el-popover
                v-if="scope.row['settleList']"
                placement="top-start"
                trigger="hover"
                width="350"
              >
                <el-table :data="scope.row['settleList']" style="width: 100%">
                  <el-table-column label="特定结算时间" width="200">
                    <template slot-scope="scope">
                      {{ new Date(scope.row.beginTime).Format('yyyy-MM-dd') }}
                      至
                      {{ new Date(scope.row.endTime).Format('yyyy-MM-dd') }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="特定结算价"
                    width="120"
                  >
                    <template slot-scope="scope">
                      ￥{{ divideByHundred(scope.row.skuSettlePrice) }}
                    </template>
                  </el-table-column>
                </el-table>
                <i
                  slot="reference"
                  class="ml5 el-icon-time"
                  style="cursor: pointer"
                ></i>
              </el-popover>
            </div>

            <div v-else-if="option.type === 'switch'">
              <el-switch
                v-model="scope.row[option.key]"
                :active-value="1"
                :inactive-value="0"
                :disabled="
                  isDisabled(option, scope) || !checkPermi([option.hasPermi])
                "
                @change="operationFn(scope, option.fn)"
              />
            </div>
            <div v-else-if="option.type === 'edit'">
              <div class="table-hover-btn">
                <div
                  v-if="
                    checkPermi([option.hasPermi]) && isStatus(option, scope)
                  "
                  class="table-hover-btn-box"
                  @click="operationFn(scope, option.fn)"
                >
                  {{ scope.row.couponNumber }}
                  <i class="el-icon-edit" style="width: 40px"></i>
                </div>
                <div v-else class="table-hover-btn-box">
                  {{
                    !!scope.row[option.key] || scope.row[option.key] === 0
                      ? scope.row[option.key]
                      : '—'
                  }}
                </div>
              </div>
            </div>

            <div v-else-if="option.type === 'img'">
              <el-image
                :fit="'scale-down'"
                :preview-src-list="[scope.row[option.key]]"
                :src="scope.row[option.key]"
                style="width: 40px; height: 40px"
              />
            </div>
            <div v-else-if="option.type === 'imgs'">
              <el-image
                :fit="'scale-down'"
                :preview-src-list="scope.row[option.key]"
                :src="scope.row[option.key][0]"
                style="width: 40px; height: 40px"
              />
            </div>
            <div v-else-if="option.type === 'dict'">
              {{ dictFn(option, scope.row[option.key]) }}
            </div>
            <div v-else-if="option.type === 'supplierName'">
              <div class="table-hover-btn" v-if="checkPermi([option.hasPermi])">
                <div
                  class="table-hover-btn-box"
                  @click="operationFn(scope, option.fn)"
                >
                  <vab-icon
                    style="cursor: pointer"
                    :style="{ color: '#1890ff' }"
                    @click="operationFn(scope, option.fn)"
                    icon="attachment-2"
                  />
                  {{ scope.row[option.key] }}
                </div>
              </div>
              <div v-else>
                {{ scope.row[option.key] }}
              </div>
            </div>

            <div v-else-if="option.type === 'name'">
              <div
                v-if="
                  option.overflow &&
                  scope.row[option.key] &&
                  scope.row[option.key].length > option.overflow
                "
              >
                <el-tooltip
                  class="item"
                  :content="scope.row[option.key]"
                  effect="dark"
                  placement="top-end"
                >
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      cursor: pointer;
                    "
                    @click="handleCopy(scope.row[option.key], option.label)"
                  >
                    {{ scope.row[option.key] }}
                  </div>
                </el-tooltip>
              </div>

              <div
                v-else-if="option.copy"
                style="cursor: pointer"
                @click="handleCopy(scope.row[option.key], option.label)"
              >
                {{
                  !!scope.row[option.key] || scope.row[option.key] === 0
                    ? scope.row[option.key]
                    : '—'
                }}
              </div>
              <div v-else>
                {{
                  !!scope.row[option.key] || scope.row[option.key] === 0
                    ? scope.row[option.key]
                    : '—'
                }}
              </div>
            </div>

            <div
              v-else-if="option.type === 'btn'"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                v-if="
                  option.text &&
                  (!!scope.row[option.key] || scope.row[option.key] === 0)
                "
                style="width: 50px"
              >
                {{ option.text }}
              </div>
              <div v-if="option.multiple">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row[option.key]"
                  placement="top-start"
                >
                  <el-button
                    v-if="
                      !!scope.row[option.key] || scope.row[option.key] === 0
                    "
                    style="flex: 1"
                    type="text"
                    @click="operationFn(scope, option.fn)"
                  >
                    {{ scope.row[option.key] }}
                  </el-button>
                </el-tooltip>
              </div>
              <div v-else>
                <el-button
                  v-if="!!scope.row[option.key] || scope.row[option.key] === 0"
                  style="flex: 1"
                  type="text"
                  @click="operationFn(scope, option.fn)"
                >
                  {{ scope.row[option.key] }}
                </el-button>
              </div>
            </div>
            <div v-else-if="option.type === 'btnxp'" class="flex-x btnxp">
              <div class="flex-y">
                <div>{{ scope.row.relatedGoodsName }}</div>
                <div>{{ scope.row.relatedGoodsSn }}</div>
              </div>
              <el-button
                class="btnxpbtn ml10"
                type="text"
                @click="operationFn(scope, option.fn)"
              >
                <i class="el-icon-edit"></i>
              </el-button>
            </div>

            <div v-else-if="option.type === 'btnGift'">
              <div
                v-if="scope.row.goodsSkuSpecs && checkPermi([option.hasPermi])"
                class="flex-x btnGift-btn"
                @click="operationFn(scope, option.fn)"
              >
                <div>
                  {{ JSON.parse(scope.row.goodsSkuSpecs).join('/') }}
                </div>

                <div class="">
                  <div class="btnGift-btn-box">
                    <i class="el-icon-edit" style="width: 40px"></i>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-button type="text" @click="operationFn(scope, option.fn)">
                  选择规格
                </el-button>
              </div>
            </div>

            <div v-else-if="option.type === 'customerLevel'">
              <el-button
                v-if="scope.row.ruleCount == null"
                type="text"
                @click="operationFn(scope, option.fn)"
              >
                选择权益
              </el-button>
              <div v-else class="">
                <span>已选{{ scope.row[option.key] }}项</span>
                <el-button
                  class="ml50"
                  type="text"
                  @click="operationFn(scope, option.fn)"
                >
                  修改
                </el-button>
              </div>
            </div>

            <div
              v-else-if="option.type === 'operation'"
              class="flex-x"
              style="justify-content: left"
            >
              <span v-for="btn_item in option.operation" :key="btn_item.text">
                <el-button
                  v-if="
                    isShowBtn(btn_item, scope) &&
                    checkPermi([btn_item.hasPermi])
                  "
                  v-preventReClick
                  class="mr10"
                  :class="{ 'text-danger': btn_item.danger }"
                  :disabled="btn_item.disabled"
                  type="text"
                  style="margin-left: 0"
                  @click="operationFn(scope, btn_item.fn)"
                >
                  {{ isShowBtn(btn_item, scope) }}
                </el-button>

                <el-button
                  v-if="
                    btn_item.type == 'btn' &&
                    scope.row.removeCauseList &&
                    scope.row.removeCauseList.length > 0
                  "
                  type="text"
                >
                  <el-tooltip effect="light" placement="right">
                    <div slot="content">
                      <div
                        v-for="(item, index) of scope.row.removeCauseList"
                        :key="index"
                        class="mb5"
                      >
                        {{ item }}
                      </div>
                    </div>
                    <div
                      v-if="scope.row.activityState != 3"
                      v-preventReClick
                      @click="operationFn(scope, btn_item.fn)"
                    >
                      删除
                      <i
                        class="el-icon-warning"
                        style="color: red; cursor: pointer"
                      ></i>
                    </div>
                  </el-tooltip>
                </el-button>

                <el-tooltip
                  v-if="
                    btn_item.type == 'btn2' &&
                    scope.row.removeCauseList &&
                    scope.row.removeCauseList.length > 0
                  "
                  effect="light"
                  placement="right"
                >
                  <div slot="content">
                    <div
                      v-for="(item, index) of scope.row.removeCauseList"
                      :key="index"
                      class="mb5"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div
                    v-if="scope.row.activityState != 3"
                    v-preventReClick
                    class="mt5"
                    style="width: 50px"
                    @click="operationFn(scope, btn_item.fn)"
                  >
                    <i
                      class="el-icon-warning"
                      style="color: red; cursor: pointer"
                    ></i>
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-if="
                    btn_item.type == 'btn3' &&
                    scope.row.removeCauseList &&
                    scope.row.removeCauseList.length > 0
                  "
                  effect="light"
                  placement="left-start"
                >
                  <div slot="content">
                    <div
                      v-for="(item, index) of scope.row.removeCauseList"
                      :key="index"
                      class="mb5"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div class="mt5" style="width: 50px">
                    <i
                      class="el-icon-warning"
                      style="color: red; cursor: pointer"
                    ></i>
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-if="
                    btn_item.type == 'btn' &&
                    scope.row.msgStatus == 0 &&
                    new Date(scope.row.sendTime) < new Date()
                  "
                  effect="light"
                  placement="right"
                >
                  <div slot="content">
                    <div v-if="scope.row.templateStatus == 3" class="mb5">
                      {{
                        '模板审核未通过：模板审核不通过，请至模板列表查看原因'
                      }}
                    </div>
                    <div v-if="scope.row.templateStatus == 1" class="mb5">
                      {{
                        '模板还在审核中：模板审核中，审核通过后，将自动给客户发送短信'
                      }}
                    </div>
                    <div v-if="scope.row.templateStatus == 0" class="mb5">
                      {{
                        '模板还在审核中：模板审核中，审核通过后，将自动给客户发送短信'
                      }}
                    </div>
                    <div v-if="scope.row.templateStatus == 2" class="mb5"></div>
                  </div>
                  <i
                    v-if="scope.row.templateStatus != 2"
                    class="el-icon-warning"
                    style="color: red; cursor: pointer"
                  ></i>
                </el-tooltip>
              </span>
            </div>
            <div v-else>
              {{
                !!scope.row[option.key] || scope.row[option.key] === 0
                  ? scope.row[option.key]
                  : '—'
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格分页 -->
      <el-row class="pagination mt10" justify="space-between" type="flex">
        <el-col class="btn-group" :span="8">
          <div
            v-if="table.tableTip"
            class="mt20"
            :style="{ color: table.tableTip.color, fontSize: '14px' }"
          >
            {{ table.tableTip.text }}
          </div>
        </el-col>
        <el-pagination
          v-if="!table.noPage && paginationShow"
          background
          class="mt10"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 30, 50, 100]"
          :current-page="params.pageNum"
          :pager-count="5"
          :auto-scroll="false"
          :size="params.pageSize"
          :total="total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </el-row>
    </div>

    <BaseDialogForm
      v-if="table.tableDialog"
      ref="dialogForm"
      :config="table.formConfig"
      :form-data="table.formModel"
      :title="dialogTitle"
      :width="table.dialogWidth"
      @submit="dialogSubmit"
    />
    <selectSupplier v-if="suppliervisible" @handleSupplier="handleSupplier" />
  </div>
</template>

<script>
  import { checkPermi } from '@/utils/permission' // 权限判断函数
  import BaseDialogForm from './BaseDialogForm.vue'
  import { checkInputNum, divideByHundred } from '@/utils'
  import {
    productSkuParamSecondCategoryList,
    productSkuParamThirdCategoryList,
    productSkuParamParamDetailList,
  } from '@/api/setting/goods/size'
  import selectSupplier from '@/components/selectSupplier'
  export default {
    name: 'BaseTable',
    components: {
      BaseDialogForm,
      selectSupplier,
    },
    props: {
      parentParam: {
        type: String,
        default: '',
      }, //父级传递过来
      table: {
        type: Object,
        default: () => {
          return {}
        },
      },
      fnInit: {
        type: Function,
        default: () => {},
      },
      count: {
        type: Boolean,
        default: false,
      },
      count2: {
        type: Boolean,
        default: false,
      },
      count3: {
        type: Boolean,
        default: false,
      },
      countItem: {
        type: Object,
        default: () => {
          return {}
        },
      },
      role: {
        type: Boolean,
        default: true,
      },
      tableParams: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        textKeyIndex: 0,
        textKeyValue: '',
        value: [],
        multipleSelection: [],
        open: false,
        loading: false, // 表格等待状态
        expand: false, // 搜索条件展开/关闭
        activeName: '', // 有tabs的话 tabs选中项
        tableData: [], // 表格数据源
        total: 0, // 表格数据总条数
        handleParams: false, // 是否重新获取一遍搜索params
        tabelradio: '',
        params: {
          // 公共参数
          pageNum: this.table.noPage ? undefined : 1,
          pageSize: this.table.noPage ? undefined : 10,
        },
        searchOptions: [], // 重置搜索参数项
        activeIcon: 0,
        suppliervisible: false, // 供应商显示隐藏
        // 活动类型
        activity: [
          {
            type: 1,
            name: '编辑活动',
            hasPermi: 'activity:popup:edit,toB:activity:popup:edit',
          },
          {
            type: 2,
            name: '删除',
            hasPermi: 'activity:popup:del,toB:activity:popup:del',
          },
          {
            type: 3,
            name: '结束活动',
            hasPermi: 'activity:popup:finish,toB:activity:popup:finish',
          },
          {
            type: 4,
            name: '活动详情',
            hasPermi: 'activity:popup:detail,toB:activity:popup:detail',
          },
        ],
        selectedObj: {},
        selectedData: [],
        // 删除结束活动
        adParams: {
          popupWindowId: null,
        },
        popupBtnType: '',
        dialogTitle: '',
        dialogType: 'add',
        clickRow: {},
        paginationShow: true,
        dictData: [],
        fold: true,
        minNum: 9, // 展开显示搜索条件数量
      }
    },
    created() {
      if (this.table.dictKey) {
        this.getDict()
      }
      this.searchOptions = { ...this.table.searchOptions }
      Object.assign(this, this.fnInit())
      if (!this.table.dictKey) {
        this._initData()
      }
    },
    methods: {
      divideByHundred,
      checkInputNum,
      checkPermi,
      // 获取列表数据
      async _initData() {
        await this.getParams()
        this.loading = true
        this.initData(Object.assign(this.table.defaultParams, this.params))
          .then((res) => {
            this.loading = false
            if (res && res.code === 200) {
              if (res.data.list) {
                this.tableData = res.data.list
                if (!this.table.noPage) {
                  this.total = parseInt(res.data.total)
                }
                if (this.tableData.length == 0 && this.params.pageNum > 1) {
                  this.params.pageNum = this.params.pageNum - 1
                  this._initData()
                }
              } else {
                this.tableData = res.data
                console.log('🚀 ~ .then ~ this.tableData:', this.tableData)
                if (this.tableData.length == 0 && this.params.pageNum > 1) {
                  this.params.pageNum = this.params.pageNum - 1
                  this._initData()
                }
              }

              this.handleRowSelection(this.tableData)
            } else {
              this.loading = false
              this.msgError(res.msg)
              this.tableData = []
              this.total = 0
            }
          })
          .catch((err) => {
            console.log('====================================')
            console.log('🚀 ~ _initData ~ err:', err)
            this.loading = false
          })
      },
      // 获取（处理）搜索项参数
      getParams() {
        if (this.table.searchOptions && this.table.searchOptions.length) {
          for (let i = 0; i < this.table.searchOptions.length; i++) {
            let item = this.table.searchOptions[i]
            if (item.value !== undefined && item.value !== null) {
              if (item.type === 'inputRange') {
                item.value = [
                  item.value1 ? Number(item.value1) : 0,
                  item.value2 ? Number(item.value2) : -1,
                ]

                if (item.value1 === 0 || item.value2 === -1) {
                  this.params[item.key] = undefined
                } else {
                  this.params[item.key] = item.value
                }
              }
              if (item.type === 'date') {
                this.params[item.key] = new Date(item.value).Format(
                  'yyyy-MM-dd'
                )
              } else if (item.type === 'datetime') {
                this.params['startTime'] = item.value[0]
                  ? new Date(item.value[0]).getTime() / 1000
                  : ''
                this.params['endTime'] = item.value[1]
                  ? new Date(item.value[1]).getTime() / 1000
                  : ''
              } else if (
                item.type === 'daterange' ||
                item.type === 'datetimerange'
              ) {
                this.params[item.key[0]] = item.value[0]
                this.params[item.key[1]] = item.value[1]
              } else if (item.type === 'multiple') {
                this.params[item.key] = item.value.join(',')
              } else if (item.type === 'sup') {
                this.params['supplierId'] = item.object.supplierId
              } else if (item.type === 'timeType') {
                this.params[item.key] = item.value
                if (
                  item.searchData[item.value].value != null &&
                  item.searchData[item.value].value.length == 2
                ) {
                  this.params[item.searchData[item.value].key[0]] =
                    item.searchData[item.value].value[0]
                  this.params[item.searchData[item.value].key[1]] =
                    item.searchData[item.value].value[1]
                } else {
                  this.params[item.searchData[item.value].key[0]] = undefined
                  this.params[item.searchData[item.value].key[1]] = undefined
                }
              } else if (item.type === 'textKey') {
                if (JSON.stringify(this.tableParams) != '{}') {
                  this.params[item.searchData[this.textKeyIndex].key] =
                    this.textKeyValue
                  item.value = this.textKeyIndex
                } else {
                  this.params[item.searchData[this.textKeyIndex].key] =
                    this.textKeyValue
                  item.value = this.textKeyIndex
                }
                if (item.searchData[this.textKeyIndex].replace) {
                  this.params[item.searchData[this.textKeyIndex].key] = this
                    .textKeyValue
                    ? this.textKeyValue.replace(/，/g, ',')
                    : undefined
                }
                this.$forceUpdate()
              } else if (item.type === 'select' && item.multiple) {
                if (item.isCache) {
                  localStorage.setItem(item.key, JSON.stringify(item.value))
                }
                if (item.value.length != 0) {
                  this.params[item.key] = item.value
                } else {
                  this.params[item.key] = undefined
                }
              } else if (
                item.type === 'cascader' ||
                item.type === 'cascader2'
              ) {
                if (item.props.multiple) {
                  let arr = []
                  item.value.forEach((row) => {
                    arr.push(row[row.length - 1])
                  })
                  this.params[item.key] = arr
                } else {
                  this.params[item.key] = item.value
                    ? item.value[item.value.length - 1]
                    : ''
                }
              } else if (item.type === 'city') {
                this.params['provinceCode'] = undefined
                this.params['cityCode'] = undefined
                this.params['districtCode'] = undefined
                if (item.value.length == 1) {
                  this.params['provinceCode'] = item.value[0]
                } else if (item.value.length == 2) {
                  this.params['provinceCode'] = item.value[0]
                  this.params['cityCode'] = item.value[1]
                } else if (item.value.length == 3) {
                  this.params['provinceCode'] = item.value[0]
                  this.params['cityCode'] = item.value[1]
                  this.params['districtCode'] = item.value[2]
                }
              } else {
                if (item.value === 0) {
                  this.params[item.key] = item.value
                } else {
                  if (item.replace) {
                    this.params[item.key] = item.value
                      ? item.value.replace(/，/g, ',')
                      : undefined
                  } else {
                    this.params[item.key] = item.value ? item.value : undefined
                  }
                }
              }
            } else {
              if (item.key instanceof Array) {
                item.key.forEach((keyRe) => {
                  this.params[keyRe] = item.value
                })
              } else if (item.type === 'timeType') {
                this.params[item.searchData[item.value].key[0]] =
                  item.searchData[item.value].value[0]
                this.params[item.searchData[item.value].key[1]] =
                  item.searchData[item.value].value[1]
                this.params[item.key[1]] = item.value[1]
              } else if (item.type === 'textKey') {
                console.log(this.textKeyIndex)
                if (JSON.stringify(this.tableParams) != '{}') {
                  this.params[item.searchData[this.textKeyIndex].key] =
                    this.textKeyValue
                  item.value = this.textKeyIndex
                } else {
                  this.params[item.searchData[this.textKeyIndex].key] =
                    this.textKeyValue
                  item.value = this.textKeyIndex
                }
                if (item.searchData[this.textKeyIndex].replace) {
                  this.params[item.searchData[this.textKeyIndex].key] = this
                    .textKeyValue
                    ? this.textKeyValue.replace(/，/g, ',')
                    : undefined
                }
                this.$forceUpdate()
              } else if (
                item.type === 'cascader' ||
                item.type === 'cascader2'
              ) {
                this.params[item.key] = item.value[0]
              } else {
                if (item.value === 0) {
                  this.params[item.key] = item.value
                } else {
                  this.params[item.key] = item.value ? item.value : undefined
                }
              }
            }
          }
        }
      },
      getDict() {
        this.getDictData(this.table.dictKey).then((res) => {
          if (res.data.applyStatus) {
            res.data.applyStatus.splice(5, 1)
          }
          if (res.data.applyType) {
            res.data.applyType.splice(1, 1)
          }
          this.dictData = res.data
          this.$nextTick(() => {
            this._initData()
          })
        })
      },
      createOrUpdate(item) {
        // 新增时，模态框数据需要拷贝基础定义的数据模型，修改时，直接拷贝当前行数据
        this.table.formModel =
          JSON.stringify(item) == 'null' ? {} : Object.assign({}, item)
        this.dialogTitle = (item ? '编辑' : '新增') + this.table.dialogTitle
        this.dialogType = item ? 'edit' : 'add'
        this.$refs.dialogForm.btnLoading = false
        this.$refs.dialogForm.resetForm()
        this.$refs.dialogForm.showDialog()
      },
      dialogSubmit(data) {
        this.$emit('getDialogResult', data)
      },
      handleRowSelection(data) {
        data.forEach((item) => {
          if (this.selectedObj[item[this.table.selectName]]) {
            this.$nextTick(() => {
              this.$refs.table.toggleRowSelection(item)
            })
          }
        })
      },
      // 刷新
      refreshTable() {
        this._initData()
      },
      handleEdit(scope) {
        let _s = this
        scope.row.edit = !scope.row.edit

        setTimeout(function () {
          _s.$refs['input' + scope.row.taskCode][0].focus()
        }, 100)
      },
      // 导出
      exportTable() {},
      // 查询
      async handleSearch() {
        this.params = this.table.defaultParams
        this.params.pageNum = 1
        // this.params.pageSize = 10;
        this._initData()
      },
      // 重置（默认参数请求）
      async clearSearch() {
        this.paginationShow = false
        this.pulldownWrite(0, 0)
        this.pulldownWrite2(0, 0)
        await this.clearOptions()
        this.loading = true
        let tmp = {
          sort: undefined,
          isAsc: undefined,
          orderBy: undefined,
          pageNum: this.table.noPage ? undefined : 1,
          pageSize: this.table.noPage ? undefined : 10,
        }
        if (this.handleParams) {
          await this.getParams()
          tmp = { ...this.params, ...tmp }
        }
        console.log(tmp, 'tmp')
        this.$refs.table.clearSort() // 清除排序
        this.params = {
          pageNum: this.table.noPage ? undefined : 1,
          pageSize: this.table.noPage ? undefined : 10,
        }
        // if (this.table.showTabs) {
        //   tmp[this.table.tabs.key] = this.table.tabs.defaultVal;
        // }
        this.initData(Object.assign(this.table.defaultParams, tmp))
          .then((res) => {
            this.paginationShow = true

            this.loading = false
            // if (res.code === 0) {
            //   this.tableData = res.data.rows;
            //   this.total = res.data.total;
            // }
            if (res.code === 200) {
              if (res.data.list) {
                this.tableData = res.data.list
                if (!this.table.noPage) {
                  this.total = parseInt(res.data.total)
                }
              } else {
                this.tableData = res.data
                this.total = parseInt(res.data.length)
              }
              this.handleRowSelection(this.tableData)
            }
          })
          .catch(() => {
            this.loading = false
          })
      },
      //切换 选项卡直接查询
      async searchSelectFn() {
        this.params.pageNum = 1
        // this.params.pageSize = 10;
        this._initData()
      },
      loadNode(node, resolve) {
        if (node.level === 3) {
          console.log('🚀 ~ node, resolve:', node, resolve)
        }

        if (node.level === 1) {
          productSkuParamSecondCategoryList({
            firstProductCategoryId: node.value,
          }).then((res2) => {
            res2.data.forEach((item) => {
              item.children = []
              item.leaf = false
            })
            return resolve(res2.data) // 初始节点示例。实际使用时，应从服务器获取数据。
          })
          // 第一级节点的处理，可根据需要调整逻辑。例如，从服务器获取数据。
        } else if (node.level === 2) {
          productSkuParamThirdCategoryList({
            secondProductCategoryId: node.value,
          }).then((res3) => {
            res3.data.forEach((item) => {
              item.children = []
              item.leaf = false
            })
            return resolve(res3.data) // 初始节点示例。实际使用时，应从服务器获取数据。
          })
        } else if (node.level === 3) {
          productSkuParamParamDetailList({
            paramType: 1,
            productCategoryId: node.value,
          }).then((res4) => {
            let data = []
            res4.data.forEach((item4) => {
              item4.categoryName = item4.detailValue
              item4.hasChildren = false
              data.push({
                categoryLevel: 4,
                categoryName: item4.detailValue,
                productCategoryId: item4.detailId,
                leaf: true,
              })
            })

            console.log('🚀 ~ res4.data.forEach ~ res4.data:', data)
            return resolve(data) // 初始节点示例。实际使用时，应从服务器获取数据。
          })
        }
      },
      //切换 选项卡直接查询
      async searchSelectFn2(value) {
        console.log('🚀 ~ searchSelectFn2 ~ value:', value)
      },

      findSelectedObject(value, options) {
        let result = null
        const findInOptions = (arr, val) => {
          for (const item of arr) {
            if (item.productCategoryId === val) {
              result = item // 找到匹配项，设置结果为该项对象
              return true // 找到匹配项，结束递归
            } else if (item.children && item.children.length > 0) {
              if (findInOptions(item.children, val)) {
                // 在子选项中递归查找
                return true // 子选项中找到匹配项，结束递归
              }
            }
          }
          return false // 未找到匹配项
        }
        findInOptions(options, value[value.length - 1]) // 只查找最后一个选中项对应的完整对象，因为 v-model 只存储了最终的选中值数组的最后一个值
        return result
      },
      // tab切换
      handleClick() {
        this.params[this.table.tabs.key] = this.activeName
        this._initData()
      },
      handleCurrentChange(val) {
        if (this.table.radio) {
          this.tabelradio = val[this.table.selectName]
          this.$emit('getRadioRow', this.tabelradio, val)
        }
      },
      handleSelectionChange(selection) {
        // el-table跨页多选
        if (this.table.selectName) {
          // 全选取消，删除当前页所有数据
          if (selection.length === 0) {
            this.tableData.forEach((item) => {
              delete this.selectedObj[item[this.table.selectName]]
            })
          }
          // 勾选数据 添加
          selection.forEach((item) => {
            this.selectedObj[item[this.table.selectName]] = item
          })
          // 获取所有分页勾选的数据
          this.selectedData = []
          for (const key in this.selectedObj) {
            this.selectedData.push(this.selectedObj[key])
          }
        }
        this.multipleSelection = this.table.selectName
          ? this.selectedData
          : selection
      },
      handleSelect(selection, row) {
        // el-table跨页多选
        // 取消单个勾选时，删除对应属性
        this.$emit('handleSelect', selection)
        if (this.table.selectName) {
          if (this.table.selectName == 'supplierId') {
            this.$emit('handleSupplier', selection)
            return
          }
          if (this.table.radio) {
            this.$emit('getRadio', selection)
            return
          }
          if (
            !selection.some(
              (item) =>
                item[this.table.selectName] === row[this.table.selectName]
            )
          ) {
            delete this.selectedObj[row[this.table.selectName]]
          }
        }
      },
      getSummaries(param) {
        console.log('🚀 ~ getSummaries ~ param:', param)
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          console.log('🚀 ~ columns.forEach ~ column:', column)
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          this.table.summarIndex.forEach((item) => {
            if (item === index) {
              const values = data.map((item) => Number(item[column.property]))

              if (!values.every((value) => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr)
                  if (!isNaN(value)) {
                    return prev + curr
                  } else {
                    return prev
                  }
                }, 0)
                sums[index]
              } else {
                sums[index] = ''
              }
            } else {
              sums[index] = ''
            }
          })
        })

        return sums
      },
      handleRowClick(row) {
        this.clickRow = row
        if (this.table.moreBtns) {
          this.table.moreBtns.forEach((item) => {
            item.disabled = false
          })
        }
      },
      // tab切换
      handleChangeTab(key, value) {
        this.activeName = value
        this.params[key] = value

        this._initData()
      },
      textKeyClearInput() {
        this.textKeyValue = ''
        this._initData()
      },
      rowstyle({ row }) {
        let stylejson = {}
        if (row.rowColor) {
          stylejson.background = row.rowColor // 背景颜色
          return stylejson
        }
      },
      pulldownWrite(val, index) {
        this.textKeyIndex = index
        this.textKeyValue = ''
        this.table.searchOptions.forEach((item) => {
          if (item.key == 'textKey') {
            // 每次切换得时候初始化

            item.searchData.forEach((el) => {
              this.params[el.key] = undefined
            })
          }
        })
      },
      pulldownWrite2(val, index) {
        this.textKeyIndex2 = index
        this.textKeyValue2 = ''
        this.table.searchOptions.forEach((item) => {
          if (item.key == 'timeType') {
            item.searchData.forEach((el) => {
              el.value = []
              this.params[el.key[0]] = ''
              this.params[el.key[1]] = ''
            })
          }
        })
      },
      // 更多功能按钮（新增、导出等）
      moreOperation(keyFn) {
        this[keyFn]()
      },
      // 列中多行内容的操作按钮
      columnBtns(scope, keyFn) {
        this[keyFn](scope)
      },
      // 多级选择当选中节点变化时触发
      selectTree(val, keyFn) {
        if (keyFn) {
          this[keyFn](val)
        }
      },
      // 控制操作列按钮显示与文案
      isShowBtn(btn_item, scope) {
        if (!this.parentParam) {
          return btn_item.isShowFn(scope)
        } else {
          let params = this.parentParam

          return btn_item.isShowFn(scope, params)
        }
      },
      toggleSearch() {
        this.table.showSearchBar = !this.table.showSearchBar
      },
      isShowState(option, scope) {
        return option.isShowState(scope)
      },

      isStatus(option, scope) {
        return option.isStatus(scope)
      },
      isDisabled(option, scope) {
        return option.isDisabled(scope)
      },
      isStateflag(option, scope) {
        if (option.isStateflag) {
          return option.isStateflag(scope)
        }
      },
      isStateColor(option, scope) {
        if (option.isStateColor) {
          return option.isStateColor(scope)
        }
      },

      dataChange(val) {
        for (var item in this.table.options) {
          const key = this.table.options[item].key
          this.table.options[item].visible = !val.includes(key)
        }
      },
      sortChange(column) {
        //获取字段名称和排序类型
        var fieldName = column.prop
        var sortingType = column.order
        //按照降序排序

        if (this.table.orderByColumn) {
          this.table.defaultParams.orderByColumn = fieldName
          if (sortingType == 'descending') {
            this.table.defaultParams.isAsc = 'desc'
          } else if (sortingType == 'ascending') {
            this.table.defaultParams.isAsc = 'asc'
          }
          //按照升序排序
          else {
            this.table.defaultParams.isAsc = 'desc'
          }
        } else {
          this.table.defaultParams.orderBy = fieldName
          if (sortingType == 'descending') {
            this.table.defaultParams.sort = 'desc'
          } else if (sortingType == 'ascending') {
            this.table.defaultParams.sort = 'asc'
          }
          //按照升序排序
          else {
            this.table.defaultParams.sort = 'desc'
          }
        }
        this.handleSearch()
      },
      // 操作列按钮事件
      operationFn(scope, keyFn) {
        this[keyFn](scope)
      },
      handleEditSubmit(scope, keyFn) {
        this[keyFn](scope)
        scope.row.edit = false
      },
      // 操作列按钮以下拉菜单形式展示
      command(e, scope) {
        this[e](scope)
      },
      dictFn(option, value) {
        if (value === null || value === undefined || value === '') return '——'
        const dict = this.dictData[option.dictKey]
        if (!dict) return '——'
        let values = Array.isArray(value) ? value : String(value).split(',')
        const descs = values
          .map((v) => {
            const trimmed = v.trim()
            const found = dict.find((item) => String(item.code) === trimmed)
            return found?.desc
          })
          .filter(Boolean)
        return descs.length ? descs.join(',') : '——'
      },
      iconChange(e, option, scope) {
        //按钮切换效果

        this.activeIcon = scope.$index

        option.iconFlag = e
      },
      selectable(row) {
        if (this.table.selectData && this.table.selectData.length > 0) {
          if (
            this.table.selectData.some((el) => {
              return (
                el[this.table.selectName ? this.table.selectName : 'userId'] ==
                row[this.table.selectName ? this.table.selectName : 'userId']
              )
            })
          ) {
            return false
          } else {
            return true
          }
        } else if (this.table.card) {
          if (
            row.status == 3 ||
            row.status == 4 ||
            row.status == 99 ||
            row.status == 1
          ) {
            return false
          } else {
            return true
          }
        } else if (this.table.withdrawal) {
          if (row.reviewerStatus !== 0) {
            return false
          } else {
            return true
          }
        } else if (this.table.giftExchange) {
          if (row.reviewStatus !== 0) {
            return false
          } else {
            return true
          }
        } else if (this.table.lockStock) {
          if (row.unlockStatus == 2) {
            return false
          } else {
            return true
          }
        } else if (this.table.applyOrder) {
          if (row.applyStatus == 0) {
            return false
          } else {
            return true
          }
        } else if (this.table.OaOrder) {
          if (
            row.applyStatus == 4 ||
            row.applyStatus == 99 ||
            row.applyStatus == 100
          ) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      },

      // 分页切换
      handlePageChange(val) {
        this.params.pageNum = val
        this._initData()
      },
      // 单页条数切换
      handleSizeChange(val) {
        this.params.pageSize = val
        this._initData()
      },
      htmlClick(event, clickObj) {
        if (event.target.getAttribute('@click')) {
          let method = event.target.getAttribute('@click')
          if (clickObj && clickObj[method] != undefined) {
            let content = clickObj[method]
            this[method](content)
          }
        }
      },
      handleSupplier(selection) {
        if (selection) {
          this.table.searchOptions.forEach((option) => {
            if (option.type == 'sup') {
              option.value = selection.supplierName
              option.object = selection
            }
          })
          this._initData()
        }
        this.suppliervisible = false
      },
      showSelectSupplier(option) {
        option.value = undefined
        this.suppliervisible = true
      },
      hideSelectSupplier() {
        this.table.searchOptions.forEach((option) => {
          if (option.type == 'sup') {
            option.value = undefined
            option.supplierId = undefined
          }
        })
        this._initData()
      },
      // 回显状态
      itemStatus(item) {
        // console.log(item)
        if (item.status == 0) {
          return '未开始'
        }
        if (item.status == 1) {
          return '进行中'
        }
        if (item.status == 2) {
          return '已结束'
        }
      },
      checkInputMax(val1, val2, type, event) {
        let that = event.target
        console.log(val1, val2, '===============')
        if (type == '1' && val2 && Number(val1) > Number(val2)) {
          that.value = ''
        } else if (type == '2' && val1 && Number(val2) < Number(val1)) {
          that.value = ''
        }
      },
      // 显示活动按钮
      activityArr(type) {
        // type 0 未开始  1活动中 2已结束
        let arr = []
        if (type == 0) {
          arr.push(this.activity[0], this.activity[1])
        }
        if (type == 1) {
          arr.push(this.activity[0], this.activity[2])
        }
        if (type == 2) {
          arr.push(this.activity[3])
        }
        return arr
      },
      handleCommand(keyFn) {
        this[keyFn]()
        console.log('🚀 ~ handleCommand ~ command:', keyFn)
      },
      // 编辑结束活动
      activityFuc(type, popupWindowId, pageType) {
        // type 1 编辑活动  2删除 3结束活动 4活动详情页
        this.adParams.popupWindowId = popupWindowId
        this.popupBtnType = type // 1 编辑活动 2 删除  3 结束活动  4 活动详情
        if (type == 1) {
          if (pageType == 'toC') {
            this.$router.push({
              name: 'ToCopenAdDetail',
              query: {
                popupWindowId: popupWindowId,
              },
            })
          } else if (pageType == 'toB') {
            this.$router.push({
              name: 'ToBopenAdDetail',
              query: {
                popupWindowId: popupWindowId,
              },
            })
          }
        }
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.table.toggleRowSelection(row)
          })
        } else {
          this.$refs.table.clearSelection()
        }
      },
      handleCopy(val, title) {
        var domUrl = document.createElement('input')
        domUrl.value = val
        domUrl.id = 'creatDom'
        document.body.appendChild(domUrl)
        domUrl.select() // 选择对象
        document.execCommand('Copy') // 执行浏览器复制命令
        let creatDom = document.getElementById('creatDom')
        creatDom.parentNode.removeChild(creatDom)
        this.msgSuccess(title + '复制成功！')
      },
      handleFold() {
        this.fold = !this.fold
        if (this.fold) {
          this.minNum = 9
        } else {
          this.minNum = 999
        }
        // this.handleHeight()
      },
      // table表头样式
      headerStyle({ rowIndex }) {
        if (rowIndex === 0) {
          return 'background:#1CD19D; color: #F2F2F2;font-weight: 600; border-bottom:1px solid #ccc;line-height:25px;height: 50px;'
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .select-left ::v-deep .el-input__inner {
    border-right: none;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
  }

  .select-right {
    margin-left: -1px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
  }

  .select-right ::v-deep .el-input__inner {
    margin-left: -1px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
  }

  .button-title {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-weight: 700;
    margin-top: -6px;
  }

  .message-content {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #fefce7;
    padding-left: 10px;
    color: #606266;
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .message-content span {
    color: #fc9e39;
    margin: 0px 20px;
  }

  .message-content span:hover {
    text-decoration-line: underline;
    cursor: pointer;
    font-weight: 800;
  }

  .table-comp {
    // background: #fff;
    // padding: 10px;
    border-radius: 6px;

    .bottom-content {
      background: #fff;
      border-radius: 6px;
      height: calc(100% - 140px);
    }

    .search {
      // display: flex;
      // justify-content: space-between;
      padding: 10px;
      background: #fff;
      margin-bottom: 12px;
      // background-color: #f00;
      border-radius: 6px;

      .search-bar {
        width: 100%;
        margin-bottom: 10px;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;

        .search-btns {
          display: flex;
          line-height: 30px;
          height: 30px;
          margin-left: 10px;
        }

        .fixed-btns {
          display: flex;
          line-height: 30px;
          height: 30px;
          margin-top: 5px;
        }

        .options-box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0;

          .options {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;

            .handle-select,
            .handle-input {
              width: 200px;
            }

            .mr10 {
              margin-bottom: 10px;
            }
          }
        }
      }

      .export-add {
        display: flex;
        flex-wrap: nowrap;

        .el-button {
          height: 32px;
        }
      }
    }

    .otherOp {
      // margin-left: 1%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      // padding-bottom: 10px;
      padding-top: 12px;

      .op-slide,
      .refresh {
        cursor: pointer;
        white-space: nowrap;
      }

      .refresh {
        margin-left: 30px;
      }

      span {
        color: #a0a0a0;
        font-size: 12px;

        & + i {
          margin-left: 5px;
        }
      }

      i {
        font-size: 12px;
        transition: all 0.3s;
        color: #a0a0a0;
      }

      .opening {
        transform: rotate(180deg);
      }
    }

    .tab-more {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .more-btns {
        margin-bottom: 10px;
      }

      .table {
        font-size: 14px;
      }
    }

    .eye {
      cursor: pointer;
      color: #1aac70;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      i {
        width: 16px;
        height: 12px;
        margin-right: 7px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }

    .search-reset {
      button {
        border-radius: 6px;
        width: 180px;
        height: 36px;
        border: 1px solid rgb(1, 206, 149);
      }

      button.search-reset-s {
        background: linear-gradient(
          0deg,
          rgb(1, 206, 149) 0%,
          rgb(59, 196, 182) 100%
        );

        &:hover {
          background: linear-gradient(
            0deg,
            rgba(1, 206, 149, 0.8) 0%,
            rgba(59, 196, 182, 0.8) 100%
          );
        }
      }
    }
  }
  .el-tooltip__popper {
    max-width: 50%;
  }
  ::v-deep .el-form-item__label {
    min-width: 66px;
    text-align: left;
  }
  .table-single-radio ::v-deep .el-radio__label {
    padding-left: 22px;
  }
</style>

<style lang="scss">
  .el-table__row .tempStorageTips {
    /* width: 45px;
    height: 30px; */
    border-top: 30px solid #e5e5e5;
    border-right: 45px solid transparent;
    font-size: 12px;
    line-height: 14px;

    /* border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    border-bottom: 100px solid red; */

    position: absolute;
    left: 0;
    top: 0;

    span {
      position: absolute;
      left: 0;
      top: -30px;
      width: 45px;
      height: 30px;
      padding-left: 2px;
    }
  }

  .origin {
    width: 8px;
    display: inline-block;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .base-tabs .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-top: 6px solid #f8f8f8;
    background: #f8f8f8;
    box-sizing: border-box;
    line-height: 30px;
    color: #a0a0a0;
  }

  .base-tabs .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 6px solid #01ce95;
    background: #fff;
    color: #1aac70;
  }

  .base-tabs .el-tabs--card > .el-tabs__header {
    border-bottom: none;
    background: #fff;
  }

  .table-comp .search .search-bar .fixed-btns {
    margin-right: -5px;
  }

  .table-comp .el-tabs__header {
    margin-bottom: 10px;
  }

  /* 操作列 最后一行按钮下有下划线的瑕疵 */
  .table-comp .el-table__fixed-right::before,
  .el-table__fixed::before {
    height: 0;
  }

  .table-comp .el-dropdown-menu .el-popper .el-dropdown-menu--small {
    left: -200px;
  }

  .table-comp .table {
    font-size: 14px;
  }

  .table-comp .el-dropdown {
    width: 100px;
    border-radius: 6px;
  }

  .taskObjBox {
    display: flex;
    flex-wrap: wrap;
  }

  .taskObjArr {
    background: #eee;
    color: #1aac70;
    padding: 0 5px;
    margin: 5px;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .btnGift-btn {
    cursor: pointer;

    i {
      color: #fff;
    }
  }

  .btnGift-btn:hover {
    i {
      margin-left: 5px;
      color: #1890ff;
    }
  }

  // 列表鼠标移动上去显隐样式
  .table-hover-btn {
    .table-hover-btn-box {
      display: flex;
      align-items: center;
      i {
        display: none;
      }
    }

    cursor: pointer;

    i {
      display: none;
    }
  }

  .table-hover-btn:hover {
    color: #1890ff;

    i {
      display: block;
    }
  }

  .bq-main {
    display: flex;

    .bm-left {
      width: 560px;
      padding: 20px;

      .bm-tags {
        height: 300px;
        overflow: auto;

        .el-tag {
          margin-right: 10px;
          margin-bottom: 10px;
          cursor: pointer;
        }
      }

      .dialog-footer {
        text-align: right;
      }
    }

    .bm-right {
      padding: 10px;
      width: 210px;
      background-color: rgba(242, 242, 242, 1);

      .br-tip span {
        float: right;
        color: #999;
      }

      .br-cont {
        height: 330px;
        padding: 10px 0;
        overflow: auto;
      }

      .br-close {
        float: right;
        width: 26px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }

  // 标签弹窗样式
  .dialog-bq ::v-deep .el-dialog__header {
    display: none;
  }

  .dialog-bq ::v-deep .el-dialog__body {
    padding: 0;
  }

  .open-ad-main {
    display: flex;

    .open-ad-img {
      position: relative;
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f2f2f2;
      margin-right: 10px;
      position: relative;

      img {
        max-width: 120px;
        max-height: 120px;
      }

      em {
        font-style: normal;
        background: rgba(255, 195, 0, 1);
        color: #fff;
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 5px;
      }

      em.in-progress1 {
        background: rgba(83, 200, 73, 1);
      }

      em.in-progress2 {
        background: rgba(185, 185, 185, 1);
      }
    }

    .open-ad-title {
      h4,
      p {
        margin: 0;
      }

      p {
        font-size: 12px;
        color: #999;
        padding-top: 3px;
      }

      h4 {
        font-size: 16px;
        margin: 5px 0;
      }
    }
  }

  .btnxp:hover {
    .btnxpbtn {
      display: block;
    }
  }

  .btnxpbtn {
    display: none;
  }
  .el-form-item__label {
    min-width: 66px;
  }
  .el-tooltip__popper {
    max-width: 50%;
  }
  .hoverable:hover .vab-icon {
    display: inline-block; /* 悬停时显示 */
  }
</style>
